export default {
  list: {},
  docs: {},
  parentOrderStatuses: [],
};
